import {types} from './types';

const setGetUsersAction = (payload) => {
    return {
        type: types.SET_USERS_LIST,
        payload,
      }
}

const setGetUserAction = (payload) => {
  return {
      type: types.SET_USER_BY_ID,
      payload,
    }
}

const setGetRezymeAction = (payload) => {
  return {
    type: types.SET_REZYME,
    payload
  }
}

const setGetLastOperationAction = (payload) => {
  return {
    type: types.SET_LAST_OPERATION,
    payload
  }
}

const setGetReplenishmentUserAction = (payload) => {
  return {
    type: types.SET_REPLENISHMENT_USER,
    payload
  }
}

const setGetWithdrawalsUserAction = (payload) => {
  return {
    type: types.SET_WITHDRAWALS_USER,
    payload,
  }
}

const setGetHistoryBonusGetByIdAction = (payload) => {
  return {
    type: types.SET_BONUSES_HISTORY,
    payload
  }
}

const setGetJackpotHistoryListAction = (payload) => {
  return {
      type: types.SET_HISTORY_LIST,
      payload,
    }
}

const setGetJackpotListAction = (payload) => {
  return {
      type: types.SET_JACKPOT,
      payload,
    }
}


export {
  setGetUsersAction,
  setGetUserAction,
  setGetRezymeAction,
  setGetLastOperationAction,
  setGetReplenishmentUserAction,
  setGetWithdrawalsUserAction,
  setGetHistoryBonusGetByIdAction,
  setGetJackpotHistoryListAction,
  setGetJackpotListAction
}